import { BellAlertIcon, BuildingOffice2Icon, CheckCircleIcon, ClockIcon, DocumentIcon, ExclamationTriangleIcon, KeyIcon, LifebuoyIcon, UserMinusIcon, XCircleIcon } from '@heroicons/react/24/outline';

import { formatDateToSydneyTimeZone } from '../utils/dateUtils';

export const NotificationIcons = ({ notificationType }) => {
  switch (notificationType) {
    case 'new-leave-request':
      return <UserMinusIcon className="h-5 w-5" />;
    case 'leave-request-approved':
      return <CheckCircleIcon className="h-5 w-5" />;
    case 'leave-request-rejected':
      return <UserMinusIcon className="h-5 w-5" />;
    case 'new-support-ticket':
      return <LifebuoyIcon className="h-5 w-5" />;
    case 'new-allocation':
      return <BuildingOffice2Icon className="h-5 w-5" />;
    case 'allocation-removed':
      return <XCircleIcon className="h-5 w-5" />;
    case 'license-expiring':
    case 'document-expiring':
      return <ClockIcon className="h-5 w-5" />;
    case 'license-expired':
    case 'document-expired':
      return <DocumentIcon className="h-5 w-5" />;
    case 'credentials-updated':
      return <KeyIcon className="h-5 w-5" />;
    case 'open-session-reminder':
      return <BellAlertIcon className="h-5 w-5" />;
    case 'open-session-admin-alert':
      return <ExclamationTriangleIcon className="h-5 w-5" />;
    case 'license-expiry':
      return <ClockIcon className="h-5 w-5" />;
    case 'document-expiry':
      return <DocumentIcon className="h-5 w-5" />;
    default:
      return null;
  }
}

export const NotificationContent = ({ data: notification, onViewLabourerClicked }) => (
  <div className='flex flex-col gap-2 p-4 text-sm border-b'>
    <p>{notification.text}</p>

    {notification.data?.expirationDate && (
      <p className='text-gray-500'>Expires: {formatDateToSydneyTimeZone(notification.data.expirationDate)}</p>
    )}

    {notification.data?.labourerUserId && onViewLabourerClicked && (
      <button
        onClick={() => onViewLabourerClicked(notification.data.labourerUserId)}
        className='self-start px-2 py-1 text-xs font-semibold rounded-md bg-ase-blue text-white'
      >
        View Labourer
      </button>
    )}
  </div>
)
